import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _values from "lodash/fp/values";
/**
 * Currently there is no better way of building custom menu groups and
 * sub-menus without modifiynig the core theme functionality.
 *
 * TODO:
 *  - improve this ugly code
 *  - check for perf. improvements
 */

import { useConfig, useMenus } from 'docz';
import { useMemo } from 'react';
export var NO_GROUP = '';

if (typeof NO_GROUP !== 'undefined' && NO_GROUP && NO_GROUP === Object(NO_GROUP) && Object.isExtensible(NO_GROUP) && !NO_GROUP.hasOwnProperty('__filemeta')) {
  Object.defineProperty(NO_GROUP, '__filemeta', {
    configurable: true,
    value: {
      name: "NO_GROUP",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/hooks/useExtendedMenus.js"
    }
  });
}

var buildSubMenus = function buildSubMenus(menuItems) {
  var map = {};
  var extendedMenu = menuItems.map(function (item) {
    if (!item.menu) return item;
    var grouped = item.menu.reduce(function (ac, subItem) {
      var i = ac.length; // part of sub-menu

      if (subItem.submenu) {
        var pos = map[subItem.submenu]; // sub-menu already exists in array

        if (pos >= 0) {
          ac[pos].menu.push(subItem);
        } // sub-menu does not exist yet
        else if (subItem.submenu) {
            ac.push({
              name: subItem.submenu,
              menu: [subItem]
            });
            map[subItem.submenu] = i;
          }

        return ac;
      } // not part of sub-menu
      // is previous item a non group item


      if (i > 0 && ac[i - 1].name === NO_GROUP) {
        ac[i - 1].menu.push(subItem);
      } // create new non group
      else {
          ac.push({
            name: NO_GROUP,
            menu: [subItem]
          });
        }

      return ac;
    }, []);
    item.extendedMenu = grouped;
    return item;
  });
  return extendedMenu;
};

var buildGroups = function buildGroups(menuItems, groups) {
  var groupKeys = Object.keys(groups); // no groups

  if (!groups || groupKeys.length === 0) {
    var _ref;

    return _ref = {}, _ref[NO_GROUP] = menuItems, _ref;
  } // map from array to object
  // where key is menu name (unique ID)


  var menusObject = menuItems.reduce(function (acc, curr) {
    acc[curr.name || ''] = curr;
    return acc;
  }, {}); // group menu items

  var grouped = groupKeys.filter(function (key) {
    return Array.isArray(groups[key]);
  }).reduce(function (acc, key) {
    // map menu item to group key
    acc[key] = groups[key].map(function (group) {
      var val = menusObject[group];
      delete menusObject[group];
      return val;
    });
    return acc;
  }, {}); // add ungrouped items

  grouped[NO_GROUP] = [].concat(_toConsumableArray(grouped[NO_GROUP] || []), _toConsumableArray(_values(menusObject) || []));
  return grouped;
};

function useExtendedMenus(_ref2) {
  var query = _ref2.query;

  var _useConfig = useConfig(),
      _useConfig$groups = _useConfig.groups,
      groups = _useConfig$groups === void 0 ? {} : _useConfig$groups;

  var menus = useMenus({
    query: query
  });
  return useMemo(function () {
    var _ref3; // if no custom menus present than return default menus


    if (!Array.isArray(menus)) return menus; // if query than return simple menu object

    if (query && query.length) return _ref3 = {}, _ref3[NO_GROUP] = menus, _ref3; // build sub menus

    var extendedMenus = buildSubMenus(menus); // build groups

    extendedMenus = buildGroups(extendedMenus, groups); // return extended menu

    return extendedMenus;
  }, [groups, menus, query]);
}

export default useExtendedMenus;

if (typeof useExtendedMenus !== 'undefined' && useExtendedMenus && useExtendedMenus === Object(useExtendedMenus) && Object.isExtensible(useExtendedMenus) && !useExtendedMenus.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useExtendedMenus, '__filemeta', {
    configurable: true,
    value: {
      name: "useExtendedMenus",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/hooks/useExtendedMenus.js"
    }
  });
}